export const webClientId = '662389364373-l9dc4jelvasbn7no4e4roogsiadmmj9g.apps.googleusercontent.com'